import React from 'react';
import { Form, Input } from 'antd';
import UsPhoneInput from 'components/form/USPhoneInput';
import SectionHeader from '../../components/SectionHeader';
import InfoTip from '../../components/InfoTip';
import OptLabel from '../../components/OptLabel';
import AddressBlock from '../../components/AddressBlock';
import s from '../../s.module.less';

// Step 3 — Billing address & contact
export default function StepAddress() {
    return (
        <div className={s.wizSection} data-wiz-section>
            <SectionHeader title="Contact information" />
            <AddressBlock ns={['address']} />
            <div className={s.wizRow}>
                <Form.Item
                    name={['address', 'phone']}
                    label={
                        <span>
                            Billing phone number
                            <InfoTip title="Payers may call this number for claim inquiries." />
                        </span>
                    }
                >
                    <UsPhoneInput size="large" placeholder="(555) 555-5555" />
                </Form.Item>
                <Form.Item
                    name={['address', 'fax']}
                    label={
                        <span>
                            <OptLabel>Fax number</OptLabel>
                            <InfoTip title="Optional fax number for payer correspondence." />
                        </span>
                    }
                >
                    <UsPhoneInput size="large" placeholder="(555) 555-5555" />
                </Form.Item>
            </div>
            <div className={s.wizRow}>
                <Form.Item name={['address', 'contactName']} label={<OptLabel>Contact name</OptLabel>}>
                    <Input size="large" placeholder="Contact name" />
                </Form.Item>
                <Form.Item name={['address', 'contactEmail']} label={<OptLabel>Contact email</OptLabel>}>
                    <Input size="large" type="email" placeholder="name@example.com" />
                </Form.Item>
            </div>
        </div>
    );
}
